package com.exura.features.plandefinition.domain.model.metadata

import kotlinx.serialization.Serializable

@Serializable
data class PlanDefinitionStatistics(
    val numberInstruction: Int,
    val numberPersistent: Int,
    val numberQuestion: Int,
    val numberFloating: Int,
    val planDuration: Int,
)
